import axios from "../utils/axios-interceptor";

export const getUsersListApi = async() => {
  try {
    const res = await axios.get("/users_list");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}